import React from 'react'
import Grid from '@material-ui/core/Grid'
import InfinityScroll from 'Components/InfinityScroll'
import User from 'EurestoClass/User'


export default (class extends React.Component {
  render () {
    return (
      <Grid container spacing={0}
            justify={'flex-start'} alignContent={'flex-start'} alignItems={'flex-start'}
            style={{ margin: 0, padding: 5, maxHeight: User.CalculHeight.getHeightWanted(), height: User.CalculHeight.getHeightWanted(), overflowY: 'auto', overflowX: 'hidden' }} id={this.props.search+ '-body'}>
        {
          this.props.data.map((d, i) => (
            <Grid xs={12} sm={12} md={6} lg={4}
                  xl={3} key={d.id + '-' + i} item style={{ margin: 0, padding: 10 }}>
              <this.props.card data={d} onClick={() => this.props.onClick(d)}/>
            </Grid>
          ))
        }
        <InfinityScroll
          over={this.props.over}
          isLoading={this.props.loading}
          search={this.props.search}
          showLoader={true}
          element={() => $('#' + this.props.search+ '-body')}
        />
      </Grid>
    )
  }
})



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/CardGrid/index.js